export const individualViewTimePeriodOptions = [
  { id: 'last_7days', label: 'Last 7 days', value: 'last_7days' },
  { id: 'last_15days', label: 'Last 15 days', value: 'last_15days' },
];
